import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './assets/latofonts.css';
import './assets/bootstrap.min.css';
import './App.scss';

class App extends Component {
  constructor () {
    let today = new Date(2026, 4, 20); // Ajustar la fecha
    today.setHours(17, 30, 0); // Ajustar la hora
    const commitMessage = "Migración AWS Fase 3 producción.";
    const shaCommit = "#####"; // Ajustar el sha del commit
    const author = "Tatiana Ramos Villanueva"; // Ajustar el autor del commit
    const featureMessage = `${new Date(today)} - ${commitMessage} - ${author} - ${shaCommit}`;
    console.info(featureMessage);
    super();
  }

  static propTypes={
    children: PropTypes.object.isRequired
  };

  render() {
    const { children }= this.props;

    return (
      <div className="App">
        { children }
      </div>
    );
  }
}

export default App;
